export default "__VITE_ASSET__$Q1$Nvve__"